import "babel-polyfill"
import React from 'react';
import { hydrate, render } from 'react-dom';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';

const rootElement = document.getElementById('root');
if (rootElement.hasChildNodes()) {
  hydrate(<App />, rootElement);
} else {
  render(<App />, rootElement);
}
// registerServiceWorker();
unregister()



// WEBPACK FOOTER //
// ./src/index.js